/* eslint-disable react-hooks/exhaustive-deps */

import { ReloadOutlined } from '@ant-design/icons';
import { Col, Row, Tag, Tooltip } from 'antd';
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import IconCameraOnvif from '../../assets/icons/camera_onvif.svg';
import IconCameraRtsp from '../../assets/icons/camera_rtsp.svg';
import Info from '../../assets/icons/info.svg';
import Info11 from '../../assets/icons/info_11.svg';
import Info12 from '../../assets/icons/info_12.svg';
import Info3 from '../../assets/icons/info_3.svg';
import Info5 from '../../assets/icons/info_5.svg';
import Info6 from '../../assets/icons/info_6.svg';
import Info7 from '../../assets/icons/info_7.svg';
import LiveIconOn from '../../assets/icons/live-streaming-on.svg';
import OffStream from '../../assets/icons/off_stream.svg';
import PlayIconNoActive from '../../assets/icons/play-button-no-active.svg';
import PlayIcon from '../../assets/icons/play-button.svg';
import Thumbnail from '../../assets/images/thumbnail.jpg';
import * as SERVICE from '../../constants/service.types';
import { NOTIFIES, ZOOM_STATE } from '../../constants/system.keys';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import {
  changeDialPadData,
  getEndStreamReturn,
  getEndStreamUtraFastReturn,
  getStartStreamMonitorFailure,
  openMessage,
  removeStartStreamMonitorFailure,
  removeStream,
  socketEmitEvent,
} from '../../redux/actions';

import { calcPercentForVideo } from '../../untils/css';
import PlayerComponent from '../Player/v2';
import { RTCCodecAdapter } from './adapter/rtc-codec';
import { HSLAdapter } from './adapter/hls';
import { RTCAdapter } from './adapter/rtc';
import { detectMediaCodec } from '../../utils/mediaCodecDetector';
import './index.scss';

import {
  editOffer,
  generateSdpFragment,
  isStreamNotFoundError,
  parseOffer,
  supportsNonAdvertisedCodec,
} from './utils';
import { useLatestCameraState } from '../../hooks/use-latest-camera-state';
import { STEP_STATE } from '../Player/StreamConnectStep';
import { beeXLogger } from '../../helpers/logger';
import { getRecoveryLivePage } from '../../redux/recovery/reducer';
import {
  addViewingCameraSerial,
  removeViewingCameraSerial,
} from '../../redux/recovery/action';

const RETRY_PAUSE = 2000;

const FIRST_LOAD_RETRY_DURATION = 15000;
const RECONNECT_RETRY_DURATION = 8000;
const STREAM_NOT_FOUND_RETRY_COOLDOWN = 5000;
const STREAM_NOT_FOUND_MAX_RETRIES = 5;

var pc_config = {
  iceServers: [{ urls: 'stun:stun01.beex.vn:3478' }],
  bundlePolicy: 'balanced',
  rtcpMuxPolicy: 'negotiate',
  sdpSemantics: 'unified-plan',
};
var pc_constraints = { optional: [{ DtlsSrtpKeyAgreement: true }] };

const INITIAL_STREAM_CONNECT_STATES = {
  1: STEP_STATE.PENDING,
  2: STEP_STATE.PENDING,
  3: STEP_STATE.PENDING,
  4: STEP_STATE.PENDING,
};

const hasHLS = (streaming) => {
  if (!streaming) {
    return false;
  }

  return (
    streaming.protocol === 'hls' ||
    (streaming.path && streaming.wsHost && streaming.hlsPort)
  );
};

const hasRTC = (streaming) => {
  if (!streaming) {
    return false;
  }

  return (
    streaming.protocol === 'webrtc' ||
    (streaming.path && streaming.wsHost && streaming.wssPort)
  );
};

const getStreamModes = (streaming) => {
  const streamModes = [];

  if (hasHLS(streaming)) {
    streamModes.push('hls');
  }

  if (hasRTC(streaming)) {
    streamModes.push('webrtc');
  }

  return streamModes;
};

const getMode = (adapter) => {
  if (adapter instanceof RTCCodecAdapter) {
    return 'webrtc';
  }

  return 'hls';
};

const getAdapter = (streaming) => {
  if (streaming.protocol === 'webrtc') {
    return RTCCodecAdapter;
  }

  if (streaming.protocol === 'hls') {
    console.log('STREAMING', JSON.parse(JSON.stringify(streaming)));
    return HSLAdapter;
  }

  if (hasRTC(streaming)) {
    return RTCCodecAdapter;
  }

  if (hasHLS(streaming)) {
    return HSLAdapter;
  }

  return HSLAdapter;
};

const sortZoomStateAsc = (z1, z2) => {
  return z1.resolution - z2.resolution;
};

const ViewStreamComponent = ({
  serial,
  gatewaySerial,
  name,
  typeCamera,
  state,
  resolution,
  iconSize,
  isInternal,
  thumbnail,
  zoomState,
  serviceId,
  isViewAll,
  permission,
  isAllowStreaming,
  allScreen,
  gridMode,
  onFullscreenChange,
  codec,
  subSources,
}) => {
  const { t } = useTranslation();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const dispatch = useDispatch();
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();

  const {
    streams,
    namespace,
    listDeviceContact,
    streamToken,
    dataUser,
    streamsFailure,
    socketState,
  } = useSelector((state) => state);
  const [streaming, setStreaming] = useState();
  const [waitForWatch, setWaitForWatch] = useState(0);
  const [streamSerial, setStreamSerial] = useState(serial);
  const [isConnected, setIsConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const refTryLoad = useRef();
  const [tryLoadTimer, setTryLoadTimer] = useState(10);
  const [isLoadReload, setIsLoadReload] = useState(false);
  const [onPlay, setOnPlay] = useState(false);
  const [checkTransferZoomState, setCheckTransferZoomState] = useState(false);
  const [zoomStatePlayer, setZoomStatePlayer] = useState();
  const [zoomStateDefault, setZoomStateDefault] = useState();
  const [internal, setInternal] = useState(false);
  const onlineRestartTimeout = useRef();
  const adapterRef = useRef();
  const [output, setOutput] = useState(null);
  const outputRef = useRef(output);
  outputRef.current = output;
  const streamRef = useRef(streaming);
  streamRef.current = streaming;
  const createStreamRetryTimeout = useRef(null);
  const videoRef = useRef(null);
  const retryRef = useRef({
    count: 0,
    // doesnt mean success but that means at this index, the stream is either success or manually selected by the user
    maxCircle: 3,
    settledAt: null,
    data: zoomState?.dataZoomStates.sort(sortZoomStateAsc) || [],
  });
  const hlsFatal = useRef(false);
  const [isStartStreamFailure, setIsStartStreamFailure] = useState(false);
  const latestState = useLatestCameraState({ serial, defaultState: state });
  const requestIdRef = useRef(null);
  const isMountedRef = useRef(true);
  const requestStreamPlayed = useRef({});
  const hasStreamOutputRef = useRef(false);
  const createStreamEffectKeyRef = useRef('');

  const isHlsRemountingRef = useRef(false);
  const streamNotFoundRetryTimeoutRef = useRef(null);
  const streamNotFoundRetryScheduledRef = useRef(false);
  const lastStreamNotFoundRetryAtRef = useRef(0);
  const streamNotFoundCountRef = useRef(0);
  const softRetryPendingRef = useRef(false);

  const [streamConnectStep, setStreamConnectStep] = useState(null);
  const [streamConnectStepStates, setStreamConnectStepStates] = useState(
    INITIAL_STREAM_CONNECT_STATES,
  );
  const [streamConnectError, setStreamConnectError] = useState(null);
  const [streamConnectErrorStep, setStreamConnectErrorStep] = useState(null);
  const { viewingCameraSerials } = useSelector(getRecoveryLivePage);

  const resetStreamConnectStatus = useCallback(() => {
    setStreamConnectError(null);
    setStreamConnectErrorStep(null);
  }, []);

  const setStreamConnectLoadingStep = useCallback((step) => {
    setStreamConnectStep(step);
    setStreamConnectStepStates({
      1: step > 1 ? STEP_STATE.DONE : STEP_STATE.LOADING,
      2:
        step > 2
          ? STEP_STATE.DONE
          : step === 2
            ? STEP_STATE.LOADING
            : STEP_STATE.PENDING,
      3:
        step > 3
          ? STEP_STATE.DONE
          : step === 3
            ? STEP_STATE.LOADING
            : STEP_STATE.PENDING,
      4: STEP_STATE.PENDING,
    });
  }, []);

  const setStreamConnectSuccess = useCallback(() => {
    setStreamConnectStep(4);
    setStreamConnectStepStates({
      1: STEP_STATE.DONE,
      2: STEP_STATE.DONE,
      3: STEP_STATE.DONE,
      4: STEP_STATE.DONE,
    });
  }, []);

  const setStreamConnectFailedAtStep3 = useCallback(() => {
    setStreamConnectStep(3);
    setStreamConnectStepStates({
      1: STEP_STATE.DONE,
      2: STEP_STATE.DONE,
      3: STEP_STATE.FAILURE,
      4: STEP_STATE.PENDING,
    });
  }, []);

  const setStreamConnectFailedAtStep2 = useCallback(() => {
    setStreamConnectStep(2);
    setStreamConnectStepStates({
      1: STEP_STATE.DONE,
      2: STEP_STATE.FAILURE,
      3: STEP_STATE.PENDING,
      4: STEP_STATE.PENDING,
    });
  }, []);

  useEffect(() => {
    if (onPlay) {
      setStreamConnectLoadingStep(1);
      resetStreamConnectStatus();
    }
  }, [onPlay, resetStreamConnectStatus, setStreamConnectLoadingStep]);

  retryRef.current.data =
    zoomState?.dataZoomStates.sort(sortZoomStateAsc) || [];

  const scheduleRetry = useCallback(
    (callback, duration = RECONNECT_RETRY_DURATION) => {
      cancelRetry();
      createStreamRetryTimeout.current = setTimeout(() => {
        retryRef.current.count++;
        createStreamRetryTimeout.current = null;
        callback();
      }, duration);
    },
    [],
  );

  const cancelRetry = useCallback(() => {
    if (createStreamRetryTimeout.current) {
      clearTimeout(createStreamRetryTimeout.current);
      createStreamRetryTimeout.current = null;
    }
  }, []);

  const clearStreamNotFoundRetryTimer = useCallback(() => {
    if (streamNotFoundRetryTimeoutRef.current) {
      clearTimeout(streamNotFoundRetryTimeoutRef.current);
      streamNotFoundRetryTimeoutRef.current = null;
    }
    streamNotFoundRetryScheduledRef.current = false;
  }, []);

  const resetStreamNotFoundRetryState = useCallback(() => {
    clearStreamNotFoundRetryTimer();
    streamNotFoundCountRef.current = 0;
    lastStreamNotFoundRetryAtRef.current = 0;
  }, [clearStreamNotFoundRetryTimer]);

  const markSettle = useCallback(() => {
    retryRef.current.settledAt = retryRef.current.count;
  }, []);

  const createStream = useCallback(
    (dataBody, caller, options = {}) => {
      const { softRetry = false } = options;
      console.log('CREATE STREAM', name, dataBody, caller);
      cancelRetry();

      if (requestIdRef.current) {
        return;
      }

      if (!navigator.onLine || socketState !== 1) {
        console.log('ABORT CREATE STREAM, NOT ONLINE', name);
        setStreamConnectError('No internet access');
        setStreamConnectErrorStep(1);
        setStreamConnectStepStates({
          1: STEP_STATE.FAILURE,
          2: STEP_STATE.PENDING,
          3: STEP_STATE.PENDING,
          4: STEP_STATE.PENDING,
        });
        if (adapterRef.current) {
          adapterRef.current.destroy();
        }
        adapterRef.current = null;
        setOutput(null);
        requestIdRef.current = null;
        dispatch(removeStream());
        setStreaming(null);
        return;
      }

      if (!softRetry) {
        resetStreamNotFoundRetryState();
        setCamPlaying(false);
        setStreamConnectLoadingStep(1);
        resetStreamConnectStatus();
        setStreaming(null);
        softRetryPendingRef.current = false;
      } else {
        softRetryPendingRef.current = true;
      }

      hasStreamOutputRef.current = false;
      isHlsRemountingRef.current = false;
      setOutput(null);

      const targetQuality =
        dataBody.qualityLevel ??
        zoomStatePlayer?.zoomState ??
        zoomState?.zoomState ??
        ZOOM_STATE.FOUR;

      const data = {
        serial: dataBody.serial,
        namespace: dataBody.namespace,
        type: dataBody.type,
        qualityLevel: Math.max(
          1,
          Math.min(targetQuality, ZOOM_STATE.SIX),
        ),
        retry: dataBody.retry,
        serviceId: dataBody.serviceId,
      };
      console.log("🚀 ~ ViewStreamComponent ~ data:", data)
      const newZoomState = zoomState?.dataZoomStates?.find(
        (item) => item.zoomState === data.qualityLevel,
      );

      console.log('NEW ZOOM STATE', newZoomState);

      if (newZoomState) {
        setZoomStatePlayer((prev) => ({
          ...prev,
          ...newZoomState,
        }));
      }

      const requestId = new Date().getTime() + Math.floor(Math.random() * 1000);

      requestIdRef.current = requestId;
      console.log('🚀 ~ START_STREAM_MONITOR ~ data:', data);

      let dataObj = {
        appServiceType: SERVICE.START_STREAM_MONITOR,
        requestId,
        body: JSON.stringify(data),
      };
      setWaitForWatch(requestId);
      dispatch(socketEmitEvent(dataObj));

      if (!softRetry) {
        setStreamConnectLoadingStep(2);
      }

      const retry = (checkHls = false) => {
        if (!isMountedRef.current || requestIdRef.current !== requestId) {
          return;
        }

        const diff = retryRef.current.count - (retryRef.current.settledAt || 0);
        const shouldForceRetry =
          diff > 0 && diff % retryRef.current.maxCircle === 0;

        const isVideoPlaying = (video) =>
          !!(
            video &&
            video.currentTime > 0 &&
            !video.paused &&
            !video.ended &&
            video.readyState > 2
          );

        const isVideoBuffering = (video) =>
          !!(
            video &&
            video.networkState === 2 &&
            video.readyState >= 1 &&
            !video.paused
          );

        if (isHlsRemountingRef.current) {
          console.log('HLS remounting in PlayerComponent, skip retry', name);
          scheduleRetry(() => retry(false), RECONNECT_RETRY_DURATION);
          return;
        }

        if (typeof outputRef.current === 'string') {
          console.log(
            'VIDEO PLAYING',
            isVideoPlaying(videoRef.current),
            'VIDEO BUFFERING',
            isVideoBuffering(videoRef.current),
          );

          if (isVideoPlaying(videoRef.current)) {
            markSettle();
            return;
          }

          if (isVideoBuffering(videoRef.current)) {
            console.log('VIDEO BUFFERING, wait more time before retry', name);
            scheduleRetry(() => retry(false), RECONNECT_RETRY_DURATION);
            return;
          }

          console.log('RETRY CREATE STREAM', shouldForceRetry);
          if (checkHls) {
            scheduleRetry(() => retry(false), RECONNECT_RETRY_DURATION);
          } else {
            requestIdRef.current = null;
            if (adapterRef.current) {
              adapterRef.current.destroy();
              adapterRef.current = null;
            }
            dispatch(removeStream(data.serial));
            createStream(
              {
                ...data,
                retry: shouldForceRetry ? 1 : 0,
              },
              'retry 1',
            );
          }
          return;
        }

        if (!outputRef.current || !videoRef.current) {
          requestIdRef.current = null;
          if (adapterRef.current) {
            adapterRef.current.destroy();
            adapterRef.current = null;
          }
          createStream(
            {
              ...data,
              retry: shouldForceRetry ? 1 : 0,
            },
            'retry 2',
          );
          return;
        }

        markSettle();
      };

      const isFirstLoad = retryRef.current.settledAt === null;
      scheduleRetry(
        () => retry(true),
        isFirstLoad ? FIRST_LOAD_RETRY_DURATION : RECONNECT_RETRY_DURATION,
      );
    },
    [
      cancelRetry,
      dispatch,
      markSettle,
      resetStreamConnectStatus,
      resetStreamNotFoundRetryState,
      scheduleRetry,
      setStreamConnectLoadingStep,
      socketState,
      zoomState,
    ],
  );

  useEffect(() => {
    if (streamsFailure) {
      if (
        Array.isArray(streamsFailure) &&
        streamsFailure?.length > 0 &&
        streamsFailure?.some((item) => item?.requestId === waitForWatch)
      ) {
        dispatch(removeStartStreamMonitorFailure(waitForWatch));
        setWaitForWatch(null);
        setIsStartStreamFailure(
          streamsFailure?.find((item) => item?.requestId === waitForWatch)
            ?.result === -4
            ? 'Connection unavailable'
            : streamsFailure?.find((item) => item?.requestId === waitForWatch)
                ?.message,
        );
      }
    } else {
      let timeout = setTimeout(() => {
        setIsStartStreamFailure(null);
      }, 300);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [streamsFailure, waitForWatch]);

  useEffect(() => {
    return () => {
      cancelRetry();
    };
  }, []);

  useEffect(() => {
    console.log('ADAPTER REF', adapterRef.current);
    if (adapterRef.current) {
      adapterRef.current.destroy();
      setOutput(null);
    }

    if (!streaming) {
      return;
    }

    const Adapter = getAdapter(streaming);

    adapterRef.current = new Adapter();
  }, [streaming?.streamMonitorId, streaming?.requestId]);

  const destroyStreaming = useCallback(() => {
    if (adapterRef.current) {
      adapterRef.current.destroy();
    }
    requestIdRef.current = null;
    dispatch(removeStream(serial));

    if (streaming?.streamMonitorId) {
      const { streamId, serial } = streaming;

      if (streamId) {
        dispatch(getEndStreamReturn(streamId));
      } else {
        dispatch(getEndStreamUtraFastReturn(serial));
      }
      let dataBody = {
        streamId,
        namespace,
      };

      let dataObj = {
        appServiceType: SERVICE.STOP_STREAM,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };

      dispatch(socketEmitEvent(dataObj));
      dispatch(getEndStreamReturn(streamId));
    }
  }, [streaming?.streamId, streaming?.serial, namespace, dispatch]);

  const executeRecreateStreamWithRetry = useCallback(
    (caller) => {
      if (streamNotFoundCountRef.current >= STREAM_NOT_FOUND_MAX_RETRIES) {
        setStreamConnectError('Stream not found');
        setStreamConnectErrorStep(3);
        setStreamConnectFailedAtStep3();
        return;
      }

      streamNotFoundCountRef.current += 1;
      lastStreamNotFoundRetryAtRef.current = Date.now();

      cancelRetry();
      markSettle();
      requestIdRef.current = null;
      requestStreamPlayed.current = {};
      hasStreamOutputRef.current = false;
      isHlsRemountingRef.current = false;
      setOutput(null);

      if (adapterRef.current) {
        adapterRef.current.destroy();
        adapterRef.current = null;
      }

      destroyStreaming();
      createStream(
        {
          namespace,
          serial,
          type: internal ? 'internal' : 'external',
          serviceId,
          qualityLevel: Math.max(
            1,
            Math.min(
              zoomStatePlayer?.zoomState ??
                zoomState?.zoomState ??
                ZOOM_STATE.FOUR,
              ZOOM_STATE.SIX,
            ),
          ),
          retry: 1,
        },
        caller || 'recreateStreamWithRetry',
        { softRetry: true },
      );
    },
    [
      cancelRetry,
      markSettle,
      destroyStreaming,
      createStream,
      namespace,
      serial,
      internal,
      serviceId,
      zoomStatePlayer?.zoomState,
      zoomState?.zoomState,
      setStreamConnectFailedAtStep3,
    ],
  );

  const recreateStreamWithRetry = useCallback(
    (caller) => {
      if (streamNotFoundCountRef.current >= STREAM_NOT_FOUND_MAX_RETRIES) {
        setStreamConnectError('Stream not found');
        setStreamConnectErrorStep(3);
        setStreamConnectFailedAtStep3();
        return;
      }

      if (streamNotFoundRetryScheduledRef.current) {
        return;
      }

      const run = () => {
        streamNotFoundRetryScheduledRef.current = false;
        executeRecreateStreamWithRetry(caller);
      };

      const now = Date.now();
      const elapsed = now - lastStreamNotFoundRetryAtRef.current;

      if (
        lastStreamNotFoundRetryAtRef.current === 0 ||
        elapsed >= STREAM_NOT_FOUND_RETRY_COOLDOWN
      ) {
        run();
        return;
      }

      streamNotFoundRetryScheduledRef.current = true;
      clearStreamNotFoundRetryTimer();
      streamNotFoundRetryTimeoutRef.current = setTimeout(() => {
        streamNotFoundRetryTimeoutRef.current = null;
        run();
      }, STREAM_NOT_FOUND_RETRY_COOLDOWN - elapsed);
    },
    [
      clearStreamNotFoundRetryTimer,
      executeRecreateStreamWithRetry,
      setStreamConnectFailedAtStep3,
    ],
  );

  const renewStreaming = useCallback(() => {
    recreateStreamWithRetry('renewStreaming');
  }, [recreateStreamWithRetry]);

  const playStreaming = useCallback(() => {
    if (!adapterRef.current || !streaming) {
      return;
    }

    if (
      requestIdRef.current &&
      requestStreamPlayed.current[requestIdRef.current]
    ) {
      return;
    }

    setStreamConnectLoadingStep(3);
    resetStreamConnectStatus();

    adapterRef.current.connect(
      streaming,
      { streamToken },
      (output) => {
        hasStreamOutputRef.current = true;
        resetStreamConnectStatus();
        setOutput(output);
        requestStreamPlayed.current = {
          ...requestStreamPlayed.current,
          [requestIdRef.current]: true,
        };
      },
      renewStreaming,
    );
  }, [
    streaming,
    streamToken,
    renewStreaming,
    resetStreamConnectStatus,
    setStreamConnectLoadingStep,
  ]);

  useEffect(() => {
    if (onPlay) {
      playStreaming();
    }
  }, [onPlay, playStreaming]);

  const sourceObject = useMemo(() => {
    if (!output) {
      return;
    }

    if (typeof output === 'string') {
      return {
        link: output,
        mode: 'hls',
      };
    }

    return output;
  }, [output]);

  useEffect(() => {
    const currentZoom = zoomStatePlayer?.zoomState ?? zoomState?.zoomState;

    // Check if current zoom level has predefined codec from subSources metadata
    let predefinedSubCodec = null;
    if (subSources && currentZoom) {
      try {
        const parsed =
          typeof subSources === 'string' ? JSON.parse(subSources) : subSources;
        if (Array.isArray(parsed)) {
          const matchedSub = parsed.find(
            (item) => item.zoomState === currentZoom,
          );
          if (matchedSub?.codec) {
            predefinedSubCodec = matchedSub.codec;
          }
        }
      } catch (e) {}
    }

    // 1. If it's a subSource stream with predefined codec, use it directly without calling detect
    if (predefinedSubCodec) {
      if (zoomStatePlayer?.codec !== predefinedSubCodec) {
        setZoomStatePlayer((prev) => ({
          ...prev,
          codec: predefinedSubCodec,
        }));
      }
      return;
    }

    // 2. If it's Main stream (or stream without predefined codec in subSources), detect every time stream connects/reloads
    if (!output) {
      if (zoomStatePlayer?.codec) {
        setZoomStatePlayer((prev) => ({
          ...prev,
          codec: null,
        }));
      }
      return;
    }

    let isCancelled = false;
    let pollInterval = null;

    const runDetect = async () => {
      const pc = adapterRef.current?.peerConnection;
      const target = pc || output || adapterRef.current?.url || adapterRef.current;

      const detected = await detectMediaCodec(target);
      if (isCancelled) return;

      if (detected && detected.codec && detected.codec !== 'UNKNOWN') {
        if (pollInterval) {
          clearInterval(pollInterval);
          pollInterval = null;
        }
        setZoomStatePlayer((prev) => ({
          ...prev,
          codec: detected.codec,
        }));
      }
    };

    runDetect();

    // Only poll for WebRTC if peerConnection is waiting for RTP packets
    if (adapterRef.current?.peerConnection) {
      let attempts = 0;
      pollInterval = setInterval(() => {
        attempts++;
        if (attempts >= 6) {
          if (pollInterval) clearInterval(pollInterval);
          pollInterval = null;
        } else {
          runDetect();
        }
      }, 500);
    }

    return () => {
      isCancelled = true;
      if (pollInterval) clearInterval(pollInterval);
    };
  }, [
    output,
    streaming?.requestId,
    streaming?.streamId,
    streaming?.streamMonitorId,
    zoomStatePlayer?.zoomState,
    subSources,
  ]);

  useEffect(() => {
    (async () => {
      if (gatewaySerial) {
        try {
          const url = `https://${gatewaySerial}.ezcam.vn:9090/info`;
          const promise = await fetch(url, {
            signal: AbortSignal.timeout(3000),
          });
          const response = await promise.json();
          setInternal(response?.localMedia === 'on');
        } catch (e) {
          setInternal(false);
        } finally {
        }
      }
    })();
  }, [gatewaySerial]);

  useEffect(() => {
    let timeoutClear;
    if (
      onPlay &&
      dataUser?.accountConfiguration &&
      JSON.parse(dataUser?.accountConfiguration)?.liveTimeout > 0
    ) {
      const dataTimeout = JSON.parse(
        dataUser?.accountConfiguration,
      )?.liveTimeout;
      timeoutClear = setTimeout(() => {
        setStreaming(null);
        setOnPlay(false);
      }, dataTimeout * 1000);
      return () => {
        clearTimeout(timeoutClear);
      };
    }
  }, [onPlay]);

  useEffect(() => {
    if (zoomState) {
      setZoomStatePlayer((prev) => {
        if (!prev) return zoomState;
        const currentZoom = prev.zoomState ?? zoomState.zoomState;
        const matched = zoomState.dataZoomStates?.find(
          (item) => item.zoomState === currentZoom,
        );
        return {
          ...zoomState,
          ...prev,
          zoomState: currentZoom,
          resolution:
            matched?.resolution ?? prev.resolution ?? zoomState.resolution,
          codec: matched?.codec ?? (prev.zoomState === currentZoom ? prev.codec : null),
        };
      });
    }
  }, [zoomState]);

  const handleTryLoad = () => {
    setIsLoadReload(true);
    refTryLoad.current = setInterval(() => {
      setTryLoadTimer((timer) => timer - 1);
    }, 1000);

    cancelRetry();
    markSettle();

    setStreamSerial(serial);
    let dataBody = {
      namespace,
      serial,
      type: internal ? 'internal' : 'external',
      serviceId,
      retry: 0,
    };
    createStream(dataBody, 'handleTryLoad');
  };

  useEffect(() => {
    if (isViewAll) {
      setOnPlay(true);
    }
  }, [isViewAll]);

  useEffect(() => {
    if (streaming && streaming.started && !isConnected) {
      clearInterval(refTryLoad.current);
      setIsConnected(true);
    }
  }, [isConnected, streaming]);

  useEffect(() => {
    if (streams && streamSerial && (!streaming || softRetryPendingRef.current)) {
      const matchedStream = streams.filter((stream) => {
        return (
          stream.serial === streamSerial &&
          stream?.requestId === requestIdRef.current
        );
      })[0];
      if (matchedStream) {
        softRetryPendingRef.current = false;
        if (!streaming) {
          setStreamConnectLoadingStep(2);
          resetStreamConnectStatus();
        }
        setStreaming(matchedStream);
        setIsStartStreamFailure(null);
      }
    }
  }, [
    streamSerial,
    streams,
    streaming,
    resetStreamConnectStatus,
    setStreamConnectLoadingStep,
  ]);

  useEffect(() => {
    return () => {
      if (!streaming) {
        if (adapterRef.current) {
          adapterRef.current.destroy();
        }
      }
    };
  }, [streaming]);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
      requestIdRef.current = null;
      requestStreamPlayed.current = {};

      cancelRetry();
      clearStreamNotFoundRetryTimer();

      if (adapterRef.current) {
        adapterRef.current.destroy();
        adapterRef.current = null;
      }

      const streamInfo = streamRef.current;

      if (
        streamInfo &&
        streamInfo.started &&
        streamInfo.status &&
        streamInfo.status.length > 0
      ) {
        const { streamId } = streamInfo;

        dispatch(
          socketEmitEvent({
            appServiceType: SERVICE.STOP_STREAM,
            requestId: Date.now(),
            body: JSON.stringify({
              streamId,
              namespace,
            }),
          }),
        );

        if (streamId) {
          dispatch(getEndStreamReturn(streamId));
        } else {
          dispatch(getEndStreamUtraFastReturn(serial));
        }
      }
      dispatch(removeStream(serial));

      streamRef.current = null;
    };
  }, [dispatch, serial, namespace, cancelRetry, clearStreamNotFoundRetryTimer]);

  // Create Stream
  useEffect(() => {
    if (!onPlay) {
      createStreamEffectKeyRef.current = '';
      return;
    }

    if (latestState <= 0) {
      return;
    }

    if (!serial || !serviceId) {
      return;
    }

    const requestKey = [
      namespace,
      serial,
      serviceId,
      internal ? 'internal' : 'external',
    ].join('|');

    if (createStreamEffectKeyRef.current === requestKey) {
      return;
    }

    createStreamEffectKeyRef.current = requestKey;

    console.log('ON PLAY', {
      onPlay,
      latestState,
      serial,
      serviceId,
    });

    setLoading(true);
    setStreamSerial(serial);
    let dataBody = {
      namespace,
      serial,
      type: internal ? 'internal' : 'external',
      serviceId,
      retry: 0,
    };
    createStream(dataBody, 'uef onPlay');
  }, [
    createStream,
    internal,
    namespace,
    onPlay,
    serial,
    serviceId,
    latestState,
  ]);

  const onChangeHover = useCallback(() => {
    if (serial && namespace) {
      let dataBody = {
        namespace,
        serial,
      };
      let dataObj = {
        appServiceType: SERVICE.GET_DEVICE_CONTACT_INFO,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [serial, namespace, dispatch]);

  const restartCallBack = useCallback(
    (dataObject) => {
      cancelRetry();
      markSettle();
      requestIdRef.current = null;

      console.log('RESTART CALLBACK:', dataObject, serial, streaming);
      if (serial) {
        if (streaming) {
          const { streamId, serial } = streaming;

          if (streamId) {
            dispatch(getEndStreamReturn(streamId));
          } else {
            dispatch(getEndStreamUtraFastReturn(serial));
          }
        }

        let dataBody = {
          namespace,
          serial,
          type: internal ? 'internal' : 'external',
          serviceId,
          qualityLevel: dataObject?.qualityLevel,
          retry: 1,
        };
        createStream(dataBody, 'restartCallBack');
      }
    },
    [createStream, dispatch, internal, namespace, serial, serviceId, streaming],
  );

  const restartLoadingCallBack = useCallback(
    (dataObject) => {
      requestIdRef.current = null;
      cancelRetry();
      markSettle();

      console.log('RESTART LOADING CALLBACK:', dataObject, serial);
      if (serial) {
        dispatch(getEndStreamUtraFastReturn(serial));

        let dataBody = {
          namespace,
          serial,
          type: internal ? 'internal' : 'external',
          serviceId,
          qualityLevel: dataObject?.qualityLevel,
          retry: 1,
        };
        createStream(dataBody, 'restartLoadingCallBack');
      }
    },
    [createStream, dispatch, internal, namespace, serial, serviceId],
  );

  const restartQualityCallBack = useCallback(
    (dataObject) => {
      requestIdRef.current = null;
      cancelRetry();
      markSettle();

      if (serial) {
        if (streaming) {
          const { streamId, serial } = streaming;

          if (streamId) {
            dispatch(getEndStreamReturn(streamId));
          } else {
            dispatch(getEndStreamUtraFastReturn(serial));
          }
        }

        let dataBody = {
          namespace,
          serial,
          type: internal ? 'internal' : 'external',
          serviceId,
          qualityLevel: dataObject?.qualityLevel,
          retry: 0,
        };
        createStream(dataBody, 'restartQualityCallBack');
      }
    },
    [createStream, dispatch, internal, namespace, serial, serviceId, streaming],
  );

  // Watch Stream
  useEffect(() => {
    if (streaming && zoomState?.zoomState && streaming.started) {
      setLoading(false);
      let dataBody = {
        streamId: streaming.streamId,
        zoomState: zoomStatePlayer?.zoomState ?? ZOOM_STATE.FOUR,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.ZOOM_STATE_STREAM,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, streaming, namespace]);

  useEffect(() => {
    return () => {
      if (adapterRef.current) {
        adapterRef.current.destroy();
      }
    };
  }, [serial, streaming?.streamMonitorId]);

  const onlineCallbackRef = useRef();

  useEffect(() => {
    onlineCallbackRef.current = {
      cancelRetry,
      markSettle,
      dispatch,
      serial,
      namespace,
      internal,
      serviceId,
      isMountedRef,
      createStream,
      name,
    };
  }, [
    cancelRetry,
    markSettle,
    dispatch,
    serial,
    namespace,
    internal,
    serviceId,
    createStream,
    name,
  ]);

  useEffect(() => {
    if (onlineRestartTimeout.current) {
      clearTimeout(onlineRestartTimeout.current);
    }

    const onOnline = () => {
      console.log('On online');
      if (onlineRestartTimeout.current) {
        clearTimeout(onlineRestartTimeout.current);
      }

      const {
        cancelRetry: cancelRetryFn,
        markSettle: markSettleFn,
        dispatch: dispatchFn,
        serial: serialVal,
        namespace: namespaceVal,
        internal: internalVal,
        serviceId: serviceIdVal,
        isMountedRef: isMountedRefVal,
        createStream: createStreamFn,
        name: nameVal,
      } = onlineCallbackRef.current;

      cancelRetryFn();
      markSettleFn();

      setOutput(null);

      if (streamRef.current) {
        const { streamId } = streamRef.current;

        if (streamId) {
          dispatchFn(getEndStreamReturn(streamId));
        } else {
          dispatchFn(getEndStreamUtraFastReturn(serialVal));
        }
      }

      onlineRestartTimeout.current = setTimeout(() => {
        if (!isMountedRefVal.current) {
          beeXLogger.log('Component unmounted, skip stream recreation');
          return;
        }

        beeXLogger.log('SOCKET RECONNECTED, RECREATE STREAM', nameVal);
        let dataBody = {
          namespace: namespaceVal,
          serial: serialVal,
          type: internalVal ? 'internal' : 'external',
          serviceId: serviceIdVal,
          retry: 0,
        };
        createStreamFn(dataBody);
      }, 3000);
    };

    window.addEventListener('online', onOnline);

    return () => {
      window.removeEventListener('online', onOnline);
      if (onlineRestartTimeout.current) {
        clearTimeout(onlineRestartTimeout.current);
        onlineRestartTimeout.current = null;
      }
    };
  }, []);

  const onRotateCamera = useCallback(
    (navigator) => {
      if (streaming?.serial) {
        let dataBody = {
          navigator,
          namespace,
          serial: streaming?.serial,
        };
        let dataObj = {
          appServiceType: SERVICE.ROTATE_VIEW_CAMERA,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, streaming],
  );

  const onZoomCamera = useCallback(
    (zoom) => {
      if (streaming?.serial) {
        let dataBody = {
          zoom,
          namespace,
          serial: streaming?.serial,
        };
        let dataObj = {
          appServiceType: SERVICE.ZOOM_VIEW_CAMERA,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, streaming],
  );

  const [camPlaying, setCamPlaying] = useState(false);

  const onError = useCallback(
    (error, value) => {
      console.error('ERROR', name, error, value);

      if (error?.name === 'AbortError') {
        return;
      }

      if (isStreamNotFoundError(error, value)) {
        recreateStreamWithRetry('onErrorStreamNotFound');
        return;
      }

      if (
        typeof value === 'object' &&
        value !== null &&
        value.fatal === false
      ) {
        hlsFatal.current = false;
        return;
      }

      hlsFatal.current = true;
      let message =
        error || error?.message || value?.message || 'Failed to load stream';

      let errorStep = 3;
      if (value?.type === 'networkError' && streamConnectStep === 2) {
        message = 'Stream not found';
        errorStep = 2;
      }

      setCamPlaying(false);
      setStreamConnectError(message);
      setStreamConnectErrorStep(errorStep);
      if (errorStep === 2) {
        setStreamConnectFailedAtStep2();
      } else {
        setStreamConnectFailedAtStep3();
      }
    },
    [
      recreateStreamWithRetry,
      setStreamConnectFailedAtStep2,
      setStreamConnectFailedAtStep3,
      streamConnectStep,
      name,
    ],
  );

  const handleOnPlay = useCallback(() => {
    setCamPlaying(true);
    hasStreamOutputRef.current = true;
    isHlsRemountingRef.current = false;
    resetStreamNotFoundRetryState();
    setStreamConnectSuccess();
    resetStreamConnectStatus();
  }, [resetStreamConnectStatus, resetStreamNotFoundRetryState, setStreamConnectSuccess]);

  useEffect(() => {
    if (camPlaying) {
      setStreamConnectSuccess();
      resetStreamConnectStatus();
    }
  }, [camPlaying, resetStreamConnectStatus, setStreamConnectSuccess]);

  useEffect(() => {
    if (isViewAll) return;
    if (
      !onPlay &&
      Array.isArray(viewingCameraSerials) &&
      viewingCameraSerials.includes(serial)
    ) {
      setOnPlay(true);
    }
  }, [onPlay, viewingCameraSerials, serial]);

  useEffect(() => {
    if (onPlay) {
      dispatch(addViewingCameraSerial(serial));
      return;
    }

    dispatch(removeViewingCameraSerial(serial));
  }, [onPlay, serial, dispatch]);

  useEffect(() => {
    return () => {
      beeXLogger.debug(
        'ViewStreamComponent unmounted, remove camera serial from recovery live page if exist',
        { serial },
      );
      dispatch(removeViewingCameraSerial(serial));
      setStreaming(null);
      if (adapterRef.current) {
        adapterRef.current.destroy();
        adapterRef.current = null;
      }
    };
  }, [serial, dispatch]);

  return (
    <div className="view-stream-component" style={{ height: '100%' }}>
      {latestState === 1 || isConnected ? (
        !camPlaying && (
          <div className="icon-live-stream">
            <img
              width={iconSize ? iconSize : 26}
              height={iconSize ? iconSize : 26}
              className="icon"
              alt="live-stream-icon"
              src={LiveIconOn}
            />
          </div>
        )
      ) : (
        <>
          <div className="name-camera">{name}</div>
          <div className="icon-live-stream">
            <img
              width={iconSize ? iconSize : 26}
              height={iconSize ? iconSize : 26}
              className="icon"
              alt="live-stream-icon"
              src={OffStream}
            />
          </div>
        </>
      )}
      {!camPlaying && (
        <Tooltip
          placement="left"
          mouseEnterDelay={0.5}
          title={
            <>
              <Row>
                <Col span={24}>
                  <Row
                    style={{
                      borderBottom: '1px solid #303030',
                      paddingBottom: '10px',
                    }}
                  >
                    <Col
                      span={18}
                      style={{
                        fontWeight: 'bold',
                        fontSize: '13px',
                        color: 'hsla(0,0%,100%,.85)',
                      }}
                    >
                      {listDeviceContact?.name || ''}
                    </Col>
                    <Col span={6}>
                      {listDeviceContact?.state === 1 ? (
                        <Tag color="rgb(14, 147, 71)">Online</Tag>
                      ) : (
                        <Tag color="rgb(79, 77, 77)">Offline</Tag>
                      )}
                    </Col>
                  </Row>
                </Col>
                {listDeviceContact?.note && (
                  <Col
                    span={24}
                    style={{
                      color: 'hsla(0, 0%, 100%, 0.65)',
                      marginTop: '10px',
                      fontSize: '13px',
                    }}
                  >
                    <img
                      className="info-icon-stream"
                      alt="live-stream-icon"
                      style={{ marginTop: '-2px' }}
                      src={Info3}
                    />
                    {listDeviceContact?.note || ''}
                  </Col>
                )}
                {latestState === 0 && (
                  <Col span={24}>
                    <Row>
                      {listDeviceContact?.errorTime && (
                        <Col
                          span={24}
                          style={{
                            color: 'hsla(0, 0%, 100%, 0.65)',
                            marginTop: '5px',
                            fontSize: '13px',
                          }}
                        >
                          <img
                            className="info-icon-stream"
                            alt="live-stream-icon"
                            style={{ marginTop: '-2px' }}
                            src={Info11}
                          />
                          {t('Time')}:{' '}
                          <span style={{ color: 'rgb(245, 47, 57)' }}>
                            {listDeviceContact?.errorTime || ''}
                          </span>
                        </Col>
                      )}
                      {listDeviceContact?.errorMessage && (
                        <Col
                          span={24}
                          style={{
                            color: 'hsla(0, 0%, 100%, 0.65)',
                            marginTop: '5px',
                            fontSize: '13px',
                          }}
                        >
                          <img
                            className="info-icon-stream"
                            alt="live-stream-icon"
                            style={{ marginTop: '-2px' }}
                            src={Info12}
                          />
                          {t('Reason')}:{' '}
                          <span style={{ color: 'rgb(245, 47, 57)' }}>
                            {listDeviceContact?.errorMessage || ''}
                          </span>
                        </Col>
                      )}
                    </Row>
                  </Col>
                )}
                <Col span={24} style={{ marginTop: '10px', fontSize: '13px' }}>
                  <img
                    className="info-icon-stream"
                    alt="live-stream-icon"
                    style={{ marginTop: '-2px' }}
                    src={Info5}
                  />
                  <span style={{ color: '#0E9347' }}>
                    {t('PERSON IN CHARGE')}
                  </span>
                </Col>
                {listDeviceContact?.assigners?.length > 0 &&
                  listDeviceContact.assigners.map((item, index) => (
                    <Col span={24} key={index}>
                      <Row>
                        {item.fullName && (
                          <Col
                            span={24}
                            style={{
                              color: 'hsla(0, 0%, 100%, 0.65)',
                              marginTop: '5px',
                              fontSize: '13px',
                            }}
                          >
                            <img
                              className="info-icon-stream"
                              alt="live-stream-icon"
                              style={{ marginTop: '-2px' }}
                              src={Info6}
                            />
                            {t('Họ tên')}: {item.fullName || ''}
                          </Col>
                        )}
                        {item.phoneNumber && (
                          <Col
                            span={24}
                            style={{
                              color: 'hsla(0, 0%, 100%, 0.65)',
                              marginTop: '5px',
                              fontSize: '13px',
                            }}
                          >
                            <img
                              className="info-icon-stream"
                              alt="live-stream-icon"
                              style={{ marginTop: '-2px' }}
                              src={Info7}
                            />
                            {t('Phone number')}:{' '}
                            <span
                              style={{
                                color: '#0E9347',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                dispatch(
                                  changeDialPadData({
                                    show: true,
                                    phone: item.phoneNumber,
                                  }),
                                );
                              }}
                            >
                              {item.phoneNumber || ''}
                            </span>
                          </Col>
                        )}
                      </Row>
                    </Col>
                  ))}
              </Row>
            </>
          }
        >
          <div className="icon-info-stream" onMouseOver={() => onChangeHover()}>
            <img
              width={iconSize ? iconSize : 26}
              height={iconSize ? iconSize : 26}
              className="icon"
              alt="live-stream-icon"
              src={Info}
            />
          </div>
        </Tooltip>
      )}
      <Tag
        color="#faad14"
        className={`connection-lost-tag ${isStartStreamFailure ? 'show' : 'hide'}`}
      >
        {t(isStartStreamFailure || '')}
      </Tag>
      {latestState === 0 &&
        !isConnected &&
        permission &&
        permission.split('_') &&
        permission.split('_').find((item) => item === 'live') && (
          <>
            <div
              onClick={() =>
                !isLoadReload && isAllowStreaming !== 0 && handleTryLoad()
              }
              className="preload-spinner reconnect"
            >
              <ReloadOutlined
                className={isAllowStreaming === 0 ? 'no-active' : ''}
                style={{ fontSize: 48 }}
                spin={isLoadReload}
              />
            </div>
            {isAllowStreaming === 0 && (
              <div className="text-no-active">
                <Tag color="#f50">{t('Not active')}</Tag>
              </div>
            )}
          </>
        )}
      {onPlay ? (
        <PlayerComponent
          name={name}
          onvif={typeCamera === 'onvif'}
          onRotate={onRotateCamera}
          onZoom={onZoomCamera}
          resolution={resolution}
          zoomStateProps={zoomStateDefault ?? zoomState}
          isFullscreenProps={isFullscreen}
          restartCallBack={restartCallBack}
          restartLoadingCallBack={restartLoadingCallBack}
          fullScreenCallBack={(isFull) => setIsFullscreen(isFull)}
          status={streaming && streaming.status}
          type="streaming"
          loading={loading}
          sourceObject={sourceObject}
          poster={thumbnail && thumbnail.match(/http/g) ? thumbnail : Thumbnail}
          setOnPlay={setOnPlay}
          serial={serial}
          checkTransferZoomState={checkTransferZoomState}
          zoomStatePlayer={zoomStatePlayer}
          setZoomStatePlayer={setZoomStatePlayer}
          restartQualityCallBack={restartQualityCallBack}
          isHlsStreaming={!!streaming?.hlsPort}
          allScreen={allScreen}
          protocol={streaming?.protocol}
          setRefVideo={(r) => (videoRef.current = r)}
          onPlay={handleOnPlay}
          onError={onError}
          selectedMode={getMode(adapterRef.current)}
          adapter={adapterRef.current}
          streamData={streaming}
          streamMonitorId={streaming && streaming?.streamMonitorId}
          namespace={namespace}
          gridMode={gridMode}
          codec={codec || zoomStatePlayer?.codec || zoomState?.codec}
          subSources={subSources}
          onFullscreenChange={onFullscreenChange}
          streamConnectStep={streamConnectStep}
          setStreamConnectStep={setStreamConnectStep}
          streamConnectStepStates={streamConnectStepStates}
          streamConnectError={streamConnectError}
          streamConnectErrorStep={streamConnectErrorStep}
          streamConnectIsSuccess={camPlaying}
          onHlsRemountingChange={(isRemounting) => {
            isHlsRemountingRef.current = isRemounting;
          }}
          onStreamNotFound={() =>
            recreateStreamWithRetry('onStreamNotFound')
          }
        />
      ) : (
        <div
          className="video-wrapper thumbnail"
          style={{
            paddingBottom: allScreen
              ? '56.25%'
              : `${calcPercentForVideo(
                  windowHeight - 108,
                  windowWidth - 324,
                )}%`,
          }}
        >
          {latestState === 1 &&
            permission &&
            permission.split('_') &&
            permission.split('_').find((item) => item === 'live') && (
              <>
                <img
                  alt="play-icon"
                  onClick={() => {
                    if (isAllowStreaming !== 0) {
                      setOnPlay(true);
                    }
                  }}
                  src={isAllowStreaming === 0 ? PlayIconNoActive : PlayIcon}
                />
                {isAllowStreaming === 0 && (
                  <div className="text-no-active">
                    <Tag color="#f50">{t('Not active')}</Tag>
                  </div>
                )}
              </>
            )}
          <video
            poster={
              thumbnail && thumbnail.match(/http/g) ? thumbnail : Thumbnail
            }
          />
        </div>
      )}
    </div>
  );
};

export default ViewStreamComponent;
